import React from 'react'
import sizeType from '../util/sizeStyle'

const Number = ({
  item,
  value,
  validationMessage,
  handleChange,
  handleFocus,
  handleBlur,
  handleKeyPress,
  defaultValue,
  formData,
}) => {
  const disabled = typeof item?.disabled === 'function' ? item?.disabled(formData) : item?.disabled || false
  const inputValue = String(value) || String(defaultValue) || ''
  const NumberRef = React.useRef(null)

  const changeValue = (val) => {
    if (handleChange) handleChange(val, item?.name)
  }
  // Return Input in view
  return (
    <div className={`${sizeType[item?.size]} !p-0`}>
      {item?.type === 'Number' && !item?.handle && (
        <style>
          {`
                        input[type="number"]::-webkit-inner-spin-button,
                        input[type="number"]::-webkit-outer-spin-button {
                            -webkit-appearance: none;
                            margin: 0;
                        }
                        
                        input[type="number"] {
                            -moz-appearance: textfield; /* Firefox */
                        }
                    `}
        </style>
      )}
      <input
        ref={NumberRef}
        onWheel={() => {
          NumberRef.current.blur()
          return false
        }}
        name={item?.name}
        type={'number'}
        placeholder={item?.placeholder}
        disabled={disabled}
        className={`transition outline-none w-[100%]
                    ${item?.disabled && 'disabled'}  
                    text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                    placeholder:text-gray-400 placeholder:text-text-md
                    focus:shadow-focus focus:border-primary-500
                    hover:border-primary-500 
                    shadow-xs
                    ${sizeType[item?.size]}
                    ${item?.innerClassName || ''} 
                    ${validationMessage ? 'border-red-500 border-2' : ''}`}
        value={inputValue}
        onChange={(e) => {
          if (handleChange) handleChange(e.target.value, item.name)
        }}
        onFocus={(e) => {
          if (item.handleFocus) item.handleFocus(e.target.value, item.name)
        }}
        onBlur={(e) => {
          if (item.handleBlur) item.handleBlur(e.target.value, item.name)
        }}
        onKeyPress={(e) => {
          if (item.handleKeyPress) item.handleKeyPress(e)
        }}
        autoFocus={item?.autoFocus}
      />
    </div>
  )
}

export default Number
